export default function Dubai() {
  return (
    <section className="relative py-24 px-12 overflow-hidden bg-gradient-to-b from-stone-100 to-stone-200">
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-10 h-1 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-full"></div>
            <span className="text-teal-600 text-sm font-bold tracking-wide uppercase">
              Middle East Strategic Expansion
            </span>
            <div className="w-10 h-1 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-full"></div>
          </div>

          <h2 className="text-stone-800 font-black text-5xl leading-tight mb-5">
            Dubai — Industrial Gas &
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500">
              Trade Logistics Hub
            </span>
          </h2>

          <p className="text-stone-600 text-lg leading-relaxed max-w-4xl mx-auto">
            SkyForge is evaluating the deployment of an Air Separation Unit within Dubai's global trade and aviation corridor to support industrial manufacturing, aerospace fueling, and regional medical infrastructure demand.
          </p>
        </div>

        {/* Main Image with Overlay Content */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-12">
          <img
            src="https://public.readdy.ai/ai/img_res/90b5e343936a89ba21a83e31d09b87aa.jpg"
            alt="Dubai Aviation and Trade Logistics Hub"
            className="w-full h-[500px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-900/70 via-stone-800/50 to-transparent"></div>
          
          {/* Overlay Content */}
          <div className="absolute inset-0 flex items-center px-16">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-teal-500/90 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg">
                  <i className="ri-plane-line text-2xl text-white"></i>
                </div>
                <span className="text-teal-300 text-sm font-bold tracking-wide uppercase">
                  Global Logistics Gateway
                </span>
              </div>
              <h3 className="text-white font-black text-3xl mb-4 leading-tight">
                Strategic Position in Global Trade & Aviation Corridor
              </h3>
              <p className="text-stone-200 text-base leading-relaxed">
                Dubai's position as a global logistics gateway provides strategic expansion leverage across Middle Eastern and European supply chains.
              </p>
            </div>
          </div>
        </div>

        {/* Infrastructure Capabilities Grid */}
        <div className="grid grid-cols-3 gap-6 mb-12">
          {/* Regional Supply */}
          <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-teal-200 rounded-2xl p-8 hover:shadow-2xl transition-all cursor-pointer">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-5 shadow-md">
              <i className="ri-flask-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-stone-800 font-bold text-lg mb-3">
              Regional Oxygen & Nitrogen Supply
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              Comprehensive industrial gas production serving manufacturing, healthcare, and energy sectors across the Middle East region.
            </p>
          </div>

          {/* Aviation & Aerospace */}
          <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-cyan-200 rounded-2xl p-8 hover:shadow-2xl transition-all cursor-pointer">
            <div className="w-14 h-14 bg-cyan-100 rounded-xl flex items-center justify-center mb-5 shadow-md">
              <i className="ri-plane-line text-2xl text-cyan-600"></i>
            </div>
            <h3 className="text-stone-800 font-bold text-lg mb-3">
              Aviation & Aerospace Alignment
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              Strategic positioning to support aerospace fueling operations, aviation maintenance, and regional flight corridor infrastructure.
            </p>
          </div>

          {/* Industrial Fabrication */}
          <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-teal-200 rounded-2xl p-8 hover:shadow-2xl transition-all cursor-pointer">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-5 shadow-md">
              <i className="ri-tools-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-stone-800 font-bold text-lg mb-3">
              Industrial Fabrication Support
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              On-demand gas supply for metal fabrication, welding operations, construction projects, and advanced manufacturing facilities.
            </p>
          </div>

          {/* Energy Sector */}
          <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-cyan-200 rounded-2xl p-8 hover:shadow-2xl transition-all cursor-pointer">
            <div className="w-14 h-14 bg-cyan-100 rounded-xl flex items-center justify-center mb-5 shadow-md">
              <i className="ri-flashlight-line text-2xl text-cyan-600"></i>
            </div>
            <h3 className="text-stone-800 font-bold text-lg mb-3">
              Energy Sector Partnerships
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              Collaboration with regional energy infrastructure providers for enhanced production efficiency and sustainable operations.
            </p>
          </div>

          {/* Free-Zone Integration */}
          <div className="bg-gradient-to-br from-stone-50 to-teal-50 border border-teal-200 rounded-2xl p-8 hover:shadow-2xl transition-all cursor-pointer">
            <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-5 shadow-md">
              <i className="ri-building-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-stone-800 font-bold text-lg mb-3">
              Free-Zone Logistics Integration
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              Seamless integration with Dubai's free-zone infrastructure enabling efficient import/export operations and regional distribution.
            </p>
          </div>

          {/* Supply Chain Leverage */}
          <div className="bg-gradient-to-br from-stone-50 to-cyan-50 border border-cyan-200 rounded-2xl p-8 hover:shadow-2xl transition-all cursor-pointer">
            <div className="w-14 h-14 bg-cyan-100 rounded-xl flex items-center justify-center mb-5 shadow-md">
              <i className="ri-global-line text-2xl text-cyan-600"></i>
            </div>
            <h3 className="text-stone-800 font-bold text-lg mb-3">
              Middle East & European Supply Chains
            </h3>
            <p className="text-stone-600 text-sm leading-relaxed">
              Strategic expansion leverage connecting Middle Eastern production with European markets through established trade corridors.
            </p>
          </div>
        </div>

        {/* Bottom Highlight Banner */}
        <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl p-8 shadow-2xl border border-teal-300">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-white font-bold text-xl mb-2">
                Global Trade Gateway Positioning
              </h3>
              <p className="text-teal-50 text-sm">
                Dubai's strategic location provides unparalleled access to Middle Eastern, European, and Asian markets — positioning SkyForge at the center of international industrial gas distribution networks.
              </p>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-plane-line text-2xl text-white"></i>
              </div>
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-building-line text-2xl text-white"></i>
              </div>
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-global-line text-2xl text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
